import { MediaQueries, Spacing } from 'UI'

export default {
  container: {
    padding: () => Spacing(10, 0, 0, 0)
  },
  image: {
    width: 150,
    height: 150
  },
  [`${MediaQueries.mobile}`]: {
    container: {
      padding: () => Spacing(3, 0, 0, 0)
    }
  },
  [`${MediaQueries.tablet}`]: {
    container: {
      padding: () => Spacing(3, 0, 0, 0)
    }
  }
}
